<main id="main-content" class="container">
    <div class="row">
        <div class="col-12 mb-3 text-center">
            <h2 i18n>En este apartado podrás consultar los números de accesos de cada uno de tus vehículos "contaminantes" en las diferentes ZBEs, durante las horas de funcionamiento de la ZBE, y compararlos con el máximo permitido según las ordenanzas de cada municipio.</h2>
            <div class="row my-5">
                <div class="col-12">
                    <p class="text-center mb-5 text-destacado" i18n>Selecciona o crea un vehículo para solicitar la revisión del número de veces que has accedido a cada ZBE. Para acceder a esta información se comprobará telemáticamente que eres titular del vehículo, sin necesidad de realizar ningún otro trámite.</p>
                </div>
                <div class="col-12 mb-3">
                    <div class="col-md-4">
                        <label for="provincia" class="form-label" i18n>Año</label>
                    </div>
                    <div class="col-md-4">
                        <select id="provincia" class="form-select" [(ngModel)]="yearSelected">
                            @for (year of years; track year) {
                            <option value="{{year}}">{{year}}</option>
                            }
                        </select>
                    </div>
                </div>
                @for (vehicle of vehicles; track vehicle.vehiclePlate) {
                <div class="col-sm-6 col-md-4 col-lg-3 mb-3 vehicle-box" (click)="selectVehicle(vehicle)"
                    [ngClass]="{'active': vehicleSelected?.vehiclePlate == vehicle.vehiclePlate || vehicleSelected == null}"
                    *ngIf="vehicle.iconCategory">
                    <app-vehicle-iccon-resume [vehicle]="vehicle"></app-vehicle-iccon-resume>
                </div>
                }
                <div class="col-sm-6 col-md-4 col-lg-3 mb-3" (click)="newVehicle()">
                    <app-vehicle-iccon-resume></app-vehicle-iccon-resume>
                </div>
            </div>
            <div class="row mb-3" *ngIf="vehicles.length < total">
                <div class="col-12 text-center">
                    <button type="button" class="btn btn-primary btn-rounded btn-full-width" (click)="loadMore()">
                        <span i18n>Cargar más</span>
                    </button>
                </div>
            </div>
        </div>
    </div>

    <div class="row" *ngIf="error" id="error">
        <div class="col-12">
            <div class="alert alert-danger" role="alert">
                {{error}}
            </div>
        </div>
    </div>

    <div class="row" *ngIf="noAccessText" id="noAccessText">
        <div class="col-12">
            <div class="alert alert-info" role="alert">
                {{noAccessText}}
            </div>
        </div>
    </div>

    <div class="row" *ngIf="accessList && accessList.municipalities.length > 0" id="accesos">
        <div class="col-12">
            <h2 class="mt-5" i18n>Accesos permitidos limitados por municipio</h2>
            <p class="text-destacado mb-4" i18n>En cada ZBE se define un número de accesos diarios permitidos por los vehículos "contaminantes" por año natural, según las ordenanzas municipales.</p>
            <p class="text-destacado mb-4" i18n>En el siguiente diagrama aparece el número de accesos diarios que se han contabilizado por el vehículo seleccionado y el límite hasta su indebido, durante las horas de funcionamiento de la ZBE. Debe tenerse en cuenta que las diferentes entradas que pueda realizar un vehículo en una determinada ZBE durante un mismo día se contabilizan como un único acceso diario.</p>
            <p class="text-destacado mb-4" i18n>Pulsando en "Ver más" obtendrás el detalle de los accesos diarios del vehículo "contaminante" que no han superado el límite establecido por cada ZBE (Permitido) y aquellos que sí superan ese límite (Penalizado).</p>
            <p class="text-destacado mb-4" i18n>En caso de que necesites más detalle de los accesos de tu vehículo, puedes ponerte en contacto con el Ayuntamiento del municipio correspondiente.</p>
            <div class="card">
                <div *ngFor="let muni of accessList.municipalities; index as i">
                    <div *ngIf="muni.detections.length > 0">
                        <h4>{{muni.location}} <button class="btn btn-primary btn-small btn-access mb-3" type="button"
                                data-bs-toggle="collapse" [attr.data-bs-target]="'#collapse'+i" aria-expanded="false"
                                aria-controls="collapseExample" i18n>
                                Ver más
                            </button></h4>
                        <div class="progress mb-3" role="progressbar" aria-label="Success example" aria-valuenow="25"
                            aria-valuemin="0" aria-valuemax="100"
                            *ngIf="muni.detectionsNonRegistered < muni.detectionsPermitted">
                            <div class="progress-bar" class="bg-success"
                                [style]="'width: ' + ((muni.detectionsNonRegistered / muni.detectionsPermitted) * 100) + '%'">
                                {{muni.detectionsNonRegistered}} /
                                {{muni.detectionsPermitted}}</div>
                        </div>
                        <div class="progress mb-3" role="progressbar" aria-label="Danger example" aria-valuenow="75"
                            aria-valuemin="0" aria-valuemax="100"
                            *ngIf="muni.detectionsNonRegistered >= muni.detectionsPermitted">
                            <div class="progress-bar" class="bg-danger"
                                [style]="'width: ' + ((muni.detectionsNonRegistered / muni.detectionsPermitted) * 100) + '%'">
                                {{muni.detectionsNonRegistered}} /
                                {{muni.detectionsPermitted}}</div>
                        </div>
                        <div class="collapse" [attr.id]="'collapse'+i">
                            <div class="card card-body mb-3">
                                <ul class="access-leyend">
                                    <li>
                                        <span class="badge text-bg-permitido shade mr-3"><span i18n>Permitido</span>
                                            <i class="bi bi-check"></i></span>
                                        <span i18n>Acceso diario compatibilizado dentro del límite marcado en la
                                            ZBE.</span>
                                    </li>
                                    <li>
                                        <span class="badge text-bg-penalizado shade mr-3"><span i18n>Penalizado</span>
                                            <i class="bi bi-x"></i></span>
                                        <span i18n>Acceso diario que supera el límite establecido en una determinada ZBE
                                            y
                                            por tanto, que se podrá penalizar.</span>
                                    </li>
                                    <li>
                                        <span class="badge text-bg-autorizado shade mr-3"><span i18n>Autorizado</span>
                                            <i class="bi bi-check"></i></span>
                                        <span i18n>Acceso diario que no se compatibiliza dentro del límite establecido
                                            en
                                            una ZBE, puesto que se ha solicitado y validado una autorización de
                                            acceso.</span>
                                    </li>
                                </ul>
                                <div class="d-none d-md-block table-responsive">
                                    <table class="table">
                                        <thead>
                                            <tr>
                                                <th scope="col" i18n>Fecha de acceso</th>
                                                <th scope="col" i18n>Municipio</th>
                                                <th scope="col" i18n>Número de acceso diario</th>
                                                <th scope="col" i18n>Estado</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let access of muni.detections; index as i">
                                                <td>{{access.timestamp.timestamp | date:'dd/MM/yyyy' }}</td>
                                                <td>{{muni.location}}</td>
                                                <td>{{access.detectionsVehicleMunicipalityDetection ||
                                                    access.number}}
                                                </td>
                                                <td><app-detection-state [state]="access.state"></app-detection-state>
                                                </td>
                                            </tr>
                                            <tr *ngIf="muni.detections.length == 0">
                                                <td colspan="4">
                                                    <span i18n>Sin accesos</span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="d-block d-md-none col-12 mb-3">
                                    <div class="accordion secondary" id="accordionDetection">
                                        <div *ngFor="let detection of muni.detections; let i = index"
                                            class="accordion-item">
                                            <h3 class="accordion-header">
                                                <button class="accordion-button collapsed" type="button"
                                                    data-bs-toggle="collapse" [attr.data-bs-target]="'#collapseD-' + i"
                                                    aria-expanded="false" [attr.aria-controls]="'collapseD-' + i">
                                                    <b>{{detection.timestamp.timestamp | date:'dd/MM/yyyy HH:mm'
                                                        }}</b><app-detection-state
                                                        [state]="detection.state"></app-detection-state>
                                                </button>
                                            </h3>
                                            <div id="collapseD-{{i}}" class="accordion-collapse collapse"
                                                data-bs-parent="#accordionFiles">
                                                <div class="row exception-container">
                                                    <div class="col-12">
                                                        <div class="row">
                                                            <p class="card-text mb-1"><span i18n>Fecha acceso:
                                                                </span>{{detection.timestamp.timestamp |
                                                                date:'dd/MM/yyyy HH:mm'}}</p>
                                                            <p class="card-text mb-1"><span i18n>Municipio:
                                                                </span>{{muni.location}}</p>
                                                            <p class="card-text mb-1"><span i18n>Acceso Nº:
                                                                </span>{{detection.detectionsVehicleMunicipalityDetection
                                                                || detection.number}}
                                                            </p>
                                                            <p class="card-text mb-1"><span i18n>Estado:
                                                                </span><app-detection-state
                                                                    [state]="detection.state"></app-detection-state>
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div *ngIf="muni.detections.length == 0">
                                            <td colspan="4">
                                                <span i18n>Sin accesos</span>
                                            </td>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</main>